import { setAppBarBuild, setAppBarContactInfoDetails } from "./AppBarSlice";
import { store } from "../../app/store";

export const setTopbarData = () => {
  fetch("./build.json")
    .then((response) => response.json())
    .then(async (data) => {
      store.dispatch(setAppBarContactInfoDetails(data));

      store.dispatch(setAppBarBuild(data));
    });
};
